import { CatHeading } from '@blocks-react/components/Heading';
import { CatButton } from '@blocks-react/components/Button';
import { CatIconArrowBack } from '@blocks-react/components/Icons/ArrowBack';
import { DrawerHeader } from '../../common';
import styles from '../DealerLocator.module.scss';
import cx from 'classnames';
import { ReactElement } from 'react';

export interface DealerLocatorHeaderProps {
  title?: string;
  children?: string | ReactElement;
  onBackButtonClick?: () => void;
  isStoreLocationMapViewUpdateFlag?: boolean;
}

export const DealerLocatorHeader = ({
  title,
  children,
  onBackButtonClick,
  isStoreLocationMapViewUpdateFlag = false
}: DealerLocatorHeaderProps) => {
  return (
    <>
      <DrawerHeader className={`${styles['drawer']} d-flex align-items-center`}>
        {!!onBackButtonClick && (
          <CatButton
            className="me-2"
            hideText
            onClick={onBackButtonClick}
            variant="ghost"
            title={title ?? ''}
          >
            <CatIconArrowBack slot="before" />
          </CatButton>
        )}
        {title && (
          <CatHeading variant="title" slot="header">
            {title}
          </CatHeading>
        )}
      </DrawerHeader>
      {!!children && (
        <p
          className={cx(
            styles['dealer-locator-text'],
            'cat-u-theme-typography-body my-3 w-auto px-1',
            { 'd-none d-md-block': isStoreLocationMapViewUpdateFlag }
          )}
        >
          {children}
        </p>
      )}
    </>
  );
};
